import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import { isValidMemberId } from '@usas/ui-web/utils/validation';

export const localValidate = (formState) => {
  let errors = {};

  //Member Id
  if (formState.memberId.trim() === '') {
    errors.memberId = 'Member Id is required';
  } else if (!isValidMemberId(formState.memberId.trim())) {
    errors.memberId = 'Member Id must be 14 alphanumeric characters';
  }

  return errors;
};

const serverValidate = async (formState) => {
  let errors = {};

  //Member Id
  const memberIdForUrl = formState.memberId ? encodeURIComponent(formState.memberId) : 'NaN';
  await PersonHttpHelper(`/Person/flat/memberId/${memberIdForUrl}`, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      }
      else {
        if (objData.isOrgRoleDurationActive === false || !(objData.personId)) {
          errors.memberId = "Member Id does not have an active member registration";
        } else {
          formState.personId = objData.personId;
        }
      }
    })
    .catch(() => {
      errors.memberId = 'Member Id is not valid';
    });

    const roleGroupIdForUrl = formState.MEET_ADMINISTRATOR_ROLE_GROUP_ID ? encodeURI(formState.MEET_ADMINISTRATOR_ROLE_GROUP_ID) : 'NaN';
    await PersonHttpHelper(`/person/member/${memberIdForUrl}/hasActiveRole?roleGroupId=${roleGroupIdForUrl}`, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          if (objData.hasActiveRole === false) {
            errors.memberId = "Member Id does not have an active meet administrator role";
          }
        }
      })
      .catch(() => {
        errors.memberId = "Member Id does not have an active meet administrator role";
      });

  return errors;
};

const MeetAdminStaffDetailValidation = async (formState) => {
  let errors = localValidate(formState);
  if (!errors || Object.keys(errors).length === 0) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
};

export default MeetAdminStaffDetailValidation;